import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userProfile } from '../redux/actions/user';

const UserContext = createContext({
   user: null,
});

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
   const [currentCompanyId, setCurrentCompanyId] = useState(null);
   const user = useSelector((state) => state?.users?.profile);
   localStorage.setItem('companyId', user?.loginhistory?.companyId);
   // localStorage.setItem('dbcode', user?.code);
   const dispatch = useDispatch();

   const setCompanyId = useCallback(() => {
      if (user && user?.loginhistory?.companyId) {
         setCurrentCompanyId(user?.loginhistory?.companyId);
      } else {
         if (user?.userRights?.length > 0) {
            setCurrentCompanyId(user?.userRights[0]?.companyId);
         }
      }
   }, [user]);

   useEffect(() => {
      dispatch(userProfile());
   }, [dispatch]);

   useEffect(() => {
      setCompanyId();
   }, [setCompanyId]);

   return <UserContext.Provider value={{ user, currentCompanyId }}>{children}</UserContext.Provider>;
};
